import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

// Feb-2026 NB Token Phase 1 — Dashboard tile (gold theme, prominent top-row placement).
// Isolated from Main Wallet / Credit Wallet. NBT is a promotional/utility token.
export default function NBTokenCard() {
  const [w, setW] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/nb-token/wallet");
        setW(data);
      } catch {
        /* ignore */
      }
    })();
  }, []);
  const balance = Number(w?.balance_total || 0);
  const value = Number(w?.value_usdt || 0);
  const price = Number(w?.current_price || 0);
  const symbol = w?.symbol || "NBT";
  const logo = w?.logo_url || "/icons/nb-token-logo.jpg";
  return (
    <Link
      to="/nb-token"
      data-testid="stat-nb-token"
      className="nb-card p-5 block hover:border-[#EAB308]/50 transition-colors relative overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, rgba(234,179,8,0.10) 0%, rgba(15,22,38,1) 60%)",
        borderColor: "rgba(234,179,8,0.25)",
      }}
    >
      <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-[#EAB308]/10 blur-2xl" />
      <div className="flex items-center justify-between text-xs uppercase tracking-widest text-slate-300">
        <span className="text-[#EAB308]">NB Token</span>
        <img
          src={logo}
          alt="NBT"
          className="h-6 w-6 rounded-full ring-1 ring-[#EAB308]/40"
          onError={(e) => (e.currentTarget.style.display = "none")}
        />
      </div>
      <div className="mt-2 font-mono text-2xl md:text-3xl font-bold text-[#EAB308]">
        {balance.toFixed(4)} <span className="text-sm">{symbol}</span>
      </div>
      <div className="text-xs text-slate-400 mt-1 flex items-center justify-between">
        <span>
          ≈ <span className="font-mono text-white">${value.toFixed(2)}</span>{" "}
          <span className="text-slate-500">@ ${price.toFixed(4)}</span>
        </span>
        <span className="text-[10px] text-nb-cyan uppercase tracking-widest">
          Wallet →
        </span>
      </div>
    </Link>
  );
}
